<template>
<div class="page">
<div class="page-header-card">
  <div class="page-header-title">
    {{ obj.unvan }}
  </div>

  <div class="page-header-sub">
   <b> {{obj.seri_sira+ ' ' +obj.tarih}}</b>
  </div>
</div>
  <div class="layout">
    <!-- SOL -->
    <section class="card card--table">
      <header class="card-head">
        <div class="card-title">Sipariş Kalemleri</div>
      </header>

      <div class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>Ürün Adı</th>
              <th class="t-right">İstenen</th>
              <th class="t-right">Teslim</th>
              <th class="t-right">Liste</th>
              <th v-if="iskontotext[0]>0" class="t-right">İskontolu</th>
              <th class="t-right">Kdv</th>
              <th class="t-right">Tutar</th>
              <th class="t-right">Onay</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in posts" :key="index">
              <td class="product">
                <div class="product-name">
                  {{ $helper.ilkharfBuyuk(item.stok).substring(0, 60) }}
                  <small style="display:block; font-weight: normal;">{{ item.satir_aciklama }}</small>

                </div>
              </td>

              <td class="t-right">
                {{ item.adet }} X {{ item.birim }}
              </td>

              <td class="t-right">
                {{ item.teslimadet + ' ' + item.birim }}
              </td>

              <td class="t-right">
                {{ $helper.parabirimi(item.liste * item.adet, hesap.pb) }}
              </td>

              <td v-if="iskontotext[0]>0" class="t-right">
                <span v-if="item.iskonto1>0">
                  {{ $helper.parabirimi(item.birim_fiyat, hesap.pb) }}
                </span>
                <span v-else>-</span>
              </td>

              <td class="t-right">
                {{ $helper.parabirimi(item.kdv, hesap.pb) }}
              </td>

              <td class="t-right">
                {{ $helper.parabirimi(item.kdv + (item.birim_fiyat * item.adet), hesap.pb) }}
              </td>

              <td class="t-right">
                <span v-if="!item.onay" class="pill pill--ok">Onaylı</span>

                <a
                  v-if="item.onay && hesap.root==1"
                  class="btn btn--danger"
                  href="javascript:void(0)"
                  @click="onayla(item.satirno)"
                >
                  Onayla
                </a>

                <span v-if="item.onay && hesap.root!=1" class="pill">Bekliyor</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="note" >
       Sipariş Notu :  {{ obj.not }}
      </div>
    </section>

    <!-- SAĞ -->
    <aside class="card card--summary">
      <header class="card-head">
        <div class="card-title">Sipariş Özeti</div>
      </header>

      <div class="summary">
        <div class="sum-row">
          <div class="sum-label">TOPLAM</div>
          <div class="sum-value">{{ $helper.parabirimi(toplam, pb) }}</div>
        </div>

        <div class="sum-row">
          <div class="sum-label">İSKONTO</div>
          <div class="sum-value">{{ $helper.parabirimi(toplam - tutar, pb) }}</div>
        </div>

        <div class="sum-row">
          <div class="sum-label">ARA TUTAR</div>
          <div class="sum-value">{{ $helper.parabirimi(tutar, pb) }}</div>
        </div>

        <div class="sum-row">
          <div class="sum-label">KDV</div>
          <div class="sum-value">{{ $helper.parabirimi(kdv, pb) }}</div>
        </div>

        <div class="sum-row sum-row--total">
          <div class="sum-label">TUTAR</div>
          <div class="sum-value">{{ $helper.parabirimi(tutar + kdv, pb) }}</div>
        </div>



      </div>
    </aside>
  </div>
  
</div>

</template>

<script>
import { router } from '@/router';


export default {

  components: {
    // fotoModal,
    // altmenu,
  },
  data() {
    return {
      source: this.$store.aktifCari,
      pb:'TL',
      obj : {},
      posts:[],
      hesap:this.$request.ayar(),
      iskontotext:[]
    };
  },
  computed: {

    toplam() {
      return this.posts.reduce((acc, item) => acc +( item.liste * item.adet), 0);
    },
      kdv() {
      return this.posts.reduce((acc, item) => acc +( item.kdv), 0);
    },
      tutar() {
      return this.posts.reduce((acc, item) => acc +( item.birim_fiyat * item.adet), 0); // kdv yukarıda eklenior
    },

  }, //AMK
  created() {
    //this.masrafGetir();
    this.getir();

    this.$store.setLoading([true,'Bekleyiniz'])

  },

  methods: {
    getir() {
      this.$request
        .post(this.hesap.program+"/siparis", {seri:this.hesap.seri,sira:this.$route.params.seri})
        .then((res) => {
          console.log(res)
          if (res.status != 309) {
    this.$store.setLoading([false,'Bekleyiniz'])
          this.obj = res.response;
          this.posts = res.response.satir;
          var iskonto = res.response.iskonto.split('+')

            iskonto.forEach(element => {
              this.iskontotext.push(element)
            });
        }
          else{
            this.$router.push("/oturum")
          }
        });
    }, 


    onayla(satir) {
      this.$swal.fire({
        title: "Onaylıyor musunuz?",
        text: "İşlem Geri alınamaz ...",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        cancelButtonText: "Hayır",

        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
    this.$store.setLoading([true,'Bekleyiniz'])
          var evrakno= this.obj.seri_sira.split("-")
          let obj = {
                seri:evrakno[0],
                sira:evrakno[1],
                satir:satir,
                mail:this.obj.ekleyenmail
          }
          console.log(obj)
          this.$request.post(this.hesap.program+"/siparissatironay", obj,this.hesap).then((response) => {
    this.$store.setLoading([false,'Bekleyiniz'])

      this.$store.showNotify({
        type: 'success',
        text: `İşlem Başarılı`,
        timeout: 3000
      });
            })
        }
      })
    },


  },
};
</script>
<style scoped>


.page{
  padding:16px;
}

.layout{
  display:grid;
  grid-template-columns: 1fr 340px;
  gap:14px;
  align-items:start;
}

.card{
  background:#fff;
  border:1px solid #e5e7eb;
  border-radius:14px;
  box-shadow: 0 1px 2px rgba(0,0,0,.04);
  overflow:hidden;
}

.card-head{
  padding:12px 14px;
  border-bottom:1px solid #f1f5f9;
  display:flex;
  align-items:center;
  justify-content:space-between;
}

.card-title{
  font-size:15px;
  font-weight:600;
  color:#0f172a;
}

.table-wrap{
  overflow:auto;
}

.data-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:13px;
}

.data-table thead th{
  position:sticky;
  top:0;
  z-index:2;
  background:#f8fafc;
  color:#334155;
  font-weight:600;
  text-align:left;
  padding:12px 12px;
  border-bottom:1px solid #e5e7eb;
  white-space:nowrap;
}

.data-table tbody td{
  padding:12px 12px;
  border-bottom:1px solid #f1f5f9;
  vertical-align:middle;
}

.data-table tbody tr:hover{
  background:#fbfdff;
}

.t-right{
  text-align:left;
  white-space:nowrap;
}

.product-name{
  font-weight:600;
  color:#0f172a;
  line-height:1.25;
}

.note{
  padding:12px 14px;
  background:#f8fafc;
  border-top:1px solid #f1f5f9;
  color:#334155;
  font-size:13px;
}

/* summary */
.summary{
  padding:12px 14px 14px;
}

.sum-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:8px 0;
  border-bottom:1px dashed #eef2f7;
}

.sum-row:last-child{
  border-bottom:none;
}

.sum-label{
  color:#475569;
  font-size:12px;
  letter-spacing:.2px;
}

.sum-value{
  font-weight:600;
  color:#0f172a;
  white-space:nowrap;
}

.sum-row--total{
  border-bottom:none;
  margin-top:6px;
  padding-top:10px;
}

.sum-row--total .sum-value{
  font-size:15px;
}

.divider{
  height:1px;
  background:#eef2f7;
  margin:12px 0;
}

.info-row{
  display:flex;
  gap:10px;
  padding:6px 0;
}

.info-label{
  width:90px;
  color:#64748b;
  font-size:12px;
}

.info-value{
  flex:1;
  color:#0f172a;
  font-weight:600;
  font-size:12px;
  word-break:break-word;
}

/* badges / buttons */
.pill{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:6px 10px;
  border-radius:999px;
  font-size:12px;
  border:1px solid #e5e7eb;
  color:#334155;
  background:#fff;
}

.pill--ok{
  border-color:#bbf7d0;
  background:#f0fdf4;
  color:#166534;
}

.btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  height:34px;
  padding:0 12px;
  border-radius:10px;
  font-size:12px;
  font-weight:600;
  text-decoration:none;
  border:1px solid transparent;
  cursor:pointer;
  white-space:nowrap;
}

.btn--danger{
  background:#ef4444;
  color:#fff;
}

/* responsive */
@media (max-width: 992px){
  .layout{
    grid-template-columns: 1fr;
  }
  .card--summary{
    order:2;
  }
  .card--table{
    order:1;
  }
}
.page-header-card{
  background:#fff;
  border:1px solid #cbd5e1;
  border-radius:12px;
  padding:16px 20px;
  margin-bottom:16px;
}

.page-header-title{
  font-size:18px;
  font-weight:700;
  color:#0f172a;
  line-height:1.3;
}

.page-header-sub{
  margin-top:6px;
  font-size:13px;
  color:#475569;
}

/* Mobil */
@media (max-width: 768px){
  .page-header-card{
    padding:14px 16px;
  }

  .page-header-title{
    font-size:16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/siparis/detay.vue